var map = {
	"./1.png": 894,
	"./10 - Copy.png": 895,
	"./10.png": 896,
	"./11.png": 897,
	"./12.png": 898,
	"./13.png": 899,
	"./14.png": 900,
	"./15.png": 901,
	"./16.png": 902,
	"./17.png": 903,
	"./18.png": 904,
	"./19.png": 905,
	"./2.png": 906,
	"./20.png": 907,
	"./21.png": 908,
	"./22.png": 909,
	"./24.png": 910,
	"./25.png": 911,
	"./26.png": 912,
	"./27.png": 913,
	"./28.png": 914,
	"./29.png": 915,
	"./31.png": 916,
	"./32.png": 917,
	"./33.png": 371,
	"./34.png": 918,
	"./35.png": 372,
	"./35_old.png": 919,
	"./4.png": 920,
	"./5.png": 921,
	"./6.png": 922,
	"./7.png": 923,
	"./8.png": 924,
	"./9.png": 925,
	"./AAVE.png": 926,
	"./ALCRYP.png": 927,
	"./AMZN.png": 928,
	"./APPL.png": 929,
	"./BCH.png": 930,
	"./BCM.png": 931,
	"./BEAM.png": 932,
	"./BNB.png": 933,
	"./BTC.png": 934,
	"./BTCB.png": 935,
	"./BUSD.png": 936,
	"./CAKE.png": 937,
	"./CHZ.png": 938,
	"./CRYC10.png": 939,
	"./DAI.png": 940,
	"./DOGE.png": 941,
	"./DOT.png": 942,
	"./EPS.png": 943,
	"./EQSTK.png": 944,
	"./ETH.png": 945,
	"./FTM.png": 946,
	"./FTT.png": 947,
	"./GOOGL.png": 948,
	"./IBAT.png": 949,
	"./IN500.png": 950,
	"./INDXXF.png": 951,
	"./INEX.png": 377,
	"./INJ.png": 952,
	"./INXC.png": 953,
	"./INXP.png": 954,
	"./IUSD+.png": 173,
	"./IUSD+_old.png": 955,
	"./IUSD.png": 956,
	"./IUSDP.png": 957,
	"./IUSDP_OLD.png": 958,
	"./IUSD_old.png": 959,
	"./LBlock.png": 960,
	"./LEO.png": 961,
	"./LINK.png": 962,
	"./LTC.png": 963,
	"./MANA.png": 964,
	"./MATIC.png": 965,
	"./META.png": 966,
	"./MSFT.png": 967,
	"./NEAR.png": 968,
	"./NOT.png": 969,
	"./NVDA.png": 970,
	"./PEP.png": 971,
	"./PYTH.png": 972,
	"./RUNE.png": 973,
	"./SHIB.png": 974,
	"./SNP500.png": 975,
	"./SOL.png": 976,
	"./TLSA.png": 977,
	"./TOB.png": 978,
	"./TON.png": 979,
	"./TRX.png": 980,
	"./TUSD.png": 981,
	"./USD.png": 982,
	"./USDC.png": 983,
	"./USDT.png": 984,
	"./WIBS.png": 985,
	"./XRP.png": 986,
	"./eth new PP lpgo 1.png": 987,
	"./inxf.png": 988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;